import request from "../utils/request";


export const getReagents = '/sampleQuotaCalc/getReagentList';

export function importReagentExcel(file: File) {
    const formData = new FormData();
    formData.append('file', file)
    return request.post('/sampleQuotaCalc/importReagents', formData);
}

export function importProportionExcel(file: File) {
    const formData = new FormData();
    formData.append('file', file)
    return request.post('/sampleQuotaCalc/importProportions', formData);
}


export function updateProduct(params: any) {
    return request.put('/sample/quotaProportion/edit', params);
}

export function deleteReagent(id: number) {
    return request.delete('/sampleQuotaCalc/deleteReagent', {params: {id}});
}

export function getReagentDetail(id: string) {
    return request.get('/sampleQuotaCalc/detail', {params: {reagentId: id}});
}

export function submitReagentProportion(data: any) {
    debugger
    return request.request({
        method: "post",
        url: '/sampleQuotaCalc/submitReagentProportion',
        data: data
    });
}

export function switchStatus(reagentId: string) {
    return request.request({
        url: '/sampleQuotaCalc/switchStatus',
        method: "get",
        params: {reagentId: reagentId}
    })
}
